import * as actionTypes from './actionTypes';

export const getAdvancedSecurityStart = () => {
  return {
    type: actionTypes.GET_ADVANCED_SECURITY_START,
    
  };
}
export const resetAdvancedSecurityState = () => {
  return {
    type: actionTypes.RESET_ADVANCED_SECURITY_STATE,
    
  };
}

export const advancedSecurityHandler = (handler) => {
  // console.log('HANDLER', handler)
  return {
    type: actionTypes.ADVANCED_SECURITY_HANDLER,
    method: handler.method,
    enabled:handler.enabled
  };
}
export const setAdvancedSecurity = (advancedSecurity) => {
  return {
    type: actionTypes.SET_ADVANCED_SECURITY,
    advancedSecurity: advancedSecurity
  };
}

export const setAdvancedSecuritySuccess = () => {
  return {
    type: actionTypes.SET_ADVANCED_SECURITY_SUCCESS
  };
}

export const setAdvancedSecurityFailed = () => {
  return {
    type: actionTypes.SET_ADVANCED_SECURITY_FAILED
  };
}



